<script lang="ts" setup>
const { user } = useUserSession();

const showNotification = computed(() => {
	return user.value && !user.value.emailVerified;
});

const isLoading = ref(false);

const handleResendClick = async () => {
	if (!user.value?.email) return;
	await navigateTo(`/auth/verify-pending?email=${encodeURIComponent(user.value.email)}`);
};

const handleResendInline = async () => {
	if (isLoading.value || !user.value?.email) return;

	isLoading.value = true;
	try {
		await $fetch('/api/auth/resend-verification', {
			method: 'POST',
			body: { email: user.value.email }
		});
		toastSuccess('Verification email sent', 'Please check your email for the verification link');
	} catch (error: any) {
		handleFetchError(error, 'Failed to send verification email', 'Please try again later', {
			400: 'Email is already verified',
			429: 'Please wait before requesting another email'
		});
	} finally {
		isLoading.value = false;
	}
};
</script>

<template>
	<div v-if="showNotification"
		class="bg-info/8 dark:bg-info/15 border-b border-info/15 dark:border-info/25 backdrop-blur-sm shadow-sm">
		<div class="px-4 py-3">
			<div class="flex items-center justify-between">
				<div class="flex items-center space-x-3 min-w-0 flex-1">
					<UIcon name="i-lucide-mail-warning" class="w-5 h-5 text-info flex-shrink-0" />
					<div class="flex-1 min-w-0">
						<p class="text-sm font-medium text-highlighted">
							Please verify your email address
						</p>
						<p class="text-sm text-muted hidden sm:block">
							Check your inbox for a verification link, or click here to resend.
						</p>
						<p class="text-xs text-muted sm:hidden">
							Check your inbox or resend verification.
						</p>
					</div>
				</div>
				<div class="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
					<UButton @click="handleResendInline" size="xs" color="info" variant="soft" icon="i-lucide-send"
						:loading="isLoading">
						<span class="hidden sm:inline">Resend</span>
					</UButton>
					<UButton @click="handleResendClick" size="xs" color="info" variant="outline" class="hidden sm:inline-flex">
						Go to verification
					</UButton>
				</div>
			</div>
		</div>
	</div>
</template>
